<script setup lang="ts">
import { toRefs, computed } from 'vue';
import CustomPopup from '@/components/common/CustomPopup.vue';

const emit = defineEmits([
  'update:modelValue',
  'clickBtn',
  'clickLeftBtn',
  'close',
]);

const props = defineProps({
  modelValue: Boolean,
  width: { type: [Number, String], default: 380 },
  height: { type: [Number, String], default: 260 },
  tip: String, //文字提示
  top: { type: String, default: '30vh' },
  type: { type: String, default: 'success' }, //success:成功图片 error:失败图片 role:生成中图片 cloud:上传中图片 tip：提示 small-tip有文案的提示
  isProgress: { type: Boolean, default: false }, //是否显示进度条
  progress: { type: Number, default: 0 }, //进度条
  btnTest: { type: String, default: '' }, //（右边）按钮文字；空则使用 common.confirm
  isShowLeftBtn: { type: Boolean, default: false }, //是否显示左边按钮
  isShowBtn: { type: Boolean, default: true }, //是否显示按钮
  leftBtnTest: { type: String, default: '' }, //左边按钮文字；空则使用 common.cancel
  smallTip: { type: String, default: '' }, //小文字提示
  secondSmallTip: { type: String, default: '' }, //第二行小文字提示
  showProgress: { type: Boolean, default: true }, //是否显示进度条
  isReverse: { type: Boolean, default: false }, //是否反转按钮颜色
  alignCenter: { type: Boolean, default: false }, //是否垂直居中
  zIndex: { type: Number, default: 99999 },
  appendToBody: { type: Boolean, default: false },
  /** 是否显示遮罩；并排洗稿预览时需 false */
  modal: { type: Boolean, default: true },
  closeOnClickModal: { type: Boolean, default: false },
});

const {
  width,
  height,
  top,
  type,
  tip,
  isProgress,
  progress,
  btnTest,
  isShowBtn,
  isShowLeftBtn,
  leftBtnTest,
  smallTip,
  showProgress,
  isReverse,
  zIndex,
  appendToBody,
  modal,
  closeOnClickModal,
} = toRefs(props);

const modelValue = computed({
  get: () => props.modelValue,
  set: (value) => emit('update:modelValue', value),
});

const closePopup = () => {
  // modelValue.value = false;
  // emit("update:modelValue", false);
  emit('close');
};

const clickBtn = () => {
  emit('clickBtn', false);
};

const clickLeftBtn = () => {
  emit('clickLeftBtn', false);
};
</script>

<template>
  <div class="popup-wrap">
    <!-- 进度类弹窗：布局已合并至 CustomPopup variant=progress -->
    <CustomPopup
      v-if="isProgress"
      v-model="modelValue"
      variant="progress"
      :progress-tip="tip || ''"
      :progress="progress"
      :show-progress-bar="showProgress"
      :progress-visual="type"
      :top="top"
      :width="width"
      :alignCenter="alignCenter"
      :z-index="zIndex"
      :append-to-body="appendToBody"
      :modal="modal"
      :isShowClose="false"
      :close-on-click-modal="closeOnClickModal"
      @close="closePopup"
    >
      <slot></slot>
    </CustomPopup>
    <CustomPopup
      v-else
      v-model="modelValue"
      :top="top"
      :width="width"
      :height="height"
      :alignCenter="alignCenter"
      :z-index="zIndex"
      :append-to-body="appendToBody"
      :modal="modal"
      @close="closePopup"
      isSuspensionHeader
      :isDanger="type == 'warning'"
    >
      <div
        class="fc-ac"
        :class="
          type == 'warning' || type == 'tip' || type == 'small-tip'
            ? 'box2'
            : 'box1'
        "
        v-if="
          type == 'success' ||
          type == 'error' ||
          type == 'warning' ||
          type == 'tip' ||
          type == 'small-tip'
        "
      >
        <img
          v-if="type == 'success'"
          class="success-img"
          src="@/assets/images/popup/img_yes.png"
          alt=""
        />
        <img
          v-else-if="type == 'error'"
          class="error-img"
          src="@/assets/images/popup/img_lose.png"
          alt=""
        />
        <img
          v-else-if="type == 'warning'"
          class="warning-img"
          src="@/assets/images/popup/img_warn.png"
          alt=""
        />
        <img
          v-else-if="type == 'tip'"
          class="tip-img"
          src="@/assets/images/popup/img_warn1.png"
          alt=""
        />
        <img
          v-else-if="type == 'small-tip'"
          class="small-tip-img"
          src="@/assets/images/popup/img_warn1.png"
          alt=""
        />
        <div
          class="fs-16 fw-500 text-center"
          style="text-align: center; width: 300px"
          :style="type === 'warning' ? 'color: #FF5D6C' : ''"
        >
          {{ tip }}
        </div>
        <slot name="smallTip">
          <div
            v-if="smallTip"
            class="mt-9"
            :class="
              type === 'warning'
                ? 'opa8 fs-14'
                : type === 'small-tip' || type === 'tip'
                ? 'fs-14'
                : 'opa6 fs-12'
            "
            style="text-align: center"
          >
            {{ smallTip }}
          </div>
        </slot>
        <div
          v-if="secondSmallTip"
          :class="
            type === 'warning'
              ? 'opa8 fs-14'
              : type === 'small-tip' || type === 'tip'
              ? 'fs-14'
              : 'opa6 fs-12'
          "
          style="text-align: center"
        >
          {{ secondSmallTip }}
        </div>
        <slot>
          <div
            class="fr-ac-jc mt-18"
            :class="
              type === 'success' || type === 'error' || type === 'tip'
                ? 'mt-30'
                : ''
            "
            v-if="isReverse"
          >
            <div
              class="color-btn mr-22"
              v-if="isShowLeftBtn"
              @click="clickLeftBtn"
            >
              {{ leftBtnTest || $t('common.cancel') }}
            </div>
            <div class="white-btn" v-if="isShowBtn" @click="clickBtn">
              {{ btnTest || $t('common.confirm') }}
            </div>
          </div>
          <div
            class="fr-ac-jc mt-18"
            :class="
              type === 'success' || type === 'error' || type === 'tip'
                ? 'mt-30'
                : ''
            "
            v-else
          >
            <div
              class="white-btn mr-22"
              v-if="isShowLeftBtn"
              @click="clickLeftBtn"
            >
              {{ leftBtnTest || $t('common.cancel') }}
            </div>
            <div class="color-btn" v-if="isShowBtn" @click="clickBtn">
              {{ btnTest || $t('common.confirm') }}
            </div>
          </div>
        </slot>
      </div>
    </CustomPopup>
  </div>
</template>

<style lang="scss" scoped>
.box1 {
  position: absolute;
  top: -38px;
  left: 50%;
  transform: translateX(-50%);
}

.box2 {
  position: relative;
}

.success-img {
  width: 264px;
  height: 138px;
  margin-bottom: 28px;
}

.error-img {
  width: 138px;
  height: 138px;
  margin-bottom: 28px;
}

.warning-img {
  width: 94px;
  height: 71px;
  margin-top: 4px;
  margin-bottom: 10px;
}

.tip-img {
  width: 84px;
  height: 84px;
  margin-bottom: 14px;
  margin-top: 4px;
}

.small-tip-img {
  width: 58px;
  height: 58px;
  margin-bottom: 12px;
}

.white-btn {
  width: 94px;
  height: 34px;
  line-height: 34px;
  text-align: center;
  background: var(--btn-bg-color);
  border-radius: var(--border-radius);
  font-size: 14px;
  color: var(--text-color);
  cursor: pointer;
}

.color-btn {
  width: 94px;
  height: 34px;
  line-height: 34px;
  text-align: center;
  background: var(--btn-bg-color-primary);
  border: 1px solid var(--border-colir-primary);
  color: var(--text-color-white);
  border-radius: var(--border-radius);
  cursor: pointer;
}
</style>
